import { render, staticRenderFns } from "./ReportSingleManagerReport.vue?vue&type=template&id=5928e31d&scoped=true&"
import script from "./ReportSingleManagerReport.vue?vue&type=script&lang=js&"
export * from "./ReportSingleManagerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928e31d",
  null
  
)

export default component.exports